import React from 'react'
import { Field, Formik, Form } from 'formik'
import { creditCardSchema } from './schema/credit_card.schema';
import { Input } from '../../../../ui/forms/formik';
import { Col, Row, Button } from 'react-bootstrap';

const ChangeCreditCardForm = ({ children, onSubmit }) => {

    return (
        <Formik
            initialValues={{cardNumber: '', cardName: '', cvv: '', expiryDate: ''}}
            validationSchema={creditCardSchema}
            onSubmit={(values, actions) => {
                onSubmit(values);
            }}
            validateOnMount
        >{(props) => (
            <Form className="formik">
                <Row>
                    <Col md={12}>
                        <Field
                            name="cardNumber"
                            label="Card Number"
                            mask="9999 9999 9999 9999"
                            placeholder="Enter Card Number"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                    <Col md={6}>
                        <Field
                            name="expiryDate"
                            label="Expiry Date"
                            mask="99/99"
                            placeholder="Enter Expiry Date"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                    <Col md={6}>
                        <Field
                            name="cvv"
                            type="password"
                            label="CVV"
                            placeholder="Enter CVV"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                    <Col md={12}>
                        <Field
                            name="cardName"
                            label="Name on Card"
                            placeholder="Enter the Name on the Card"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        {children}
                    </Col>
                    <Col md={6}>
                        <Button
                            variant="primary"
                            disabled={!(props.isValid && props.dirty)}
                            className="lg"
                            size="xl"
                            block
                            type="submit"
                        >Add Card</Button>
                    </Col>
                </Row>
            </Form>
        )}
        </Formik>
    )
}

export default ChangeCreditCardForm
